/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { boFont } from '@components/systems/backoffice/backoffice.tokens'

import { AccessGroupType } from '@schemas'

interface PropsType {
	group: AccessGroupType
}

export const AccessGroupListItem = (props: PropsType) => {
	const { group } = props

	return (
		<View css={style}>
			<View className="groupInnerView">
				<View>
					<Text className="name" as="span" i18n={group.i18n}>
						{group.name}
					</Text>
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',

	'.groupInnerView': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		padding: '0.5rem 0',

		'.name': {
			margin: 0,
			fontFamily: boFont.ui,
			fontSize: 13,
			fontWeight: 400,
			lineHeight: 1.3,
			color: 'inherit',
			textAlign: 'left',
		},
	},
})
